import { REQUEST_SOURCE_MODE } from 'constants/api';
import { checkIsAppLoadedInIframe } from 'utils/iframe';

/* The mint endpoints (sign-in, refresh, impersonation) accept the source mode
   from the `sourceMode` request header and embed it as a JWT claim on the
   issued access token. Post-mint reads use that claim, so this header only
   needs to ride along with token-issuing requests. */
export const getRequestSourceMode = () =>
  checkIsAppLoadedInIframe() ? REQUEST_SOURCE_MODE.IFRAME : REQUEST_SOURCE_MODE.BROWSER;
